import React from 'react';

const toRad = (d) => (d * Math.PI) / 180;

// Renders a photo so it always fits its container (aspect ratio kept) while honouring the
// admin "display" settings: background colour/transparency, image opacity, fit, and an
// optional display-only crop/rotate "view" (so the stored file stays untouched).
export default function PhotoFrame({ src, display = {}, alt = '', className = '', style = {}, imgClassName = '', testId, onClick }) {
  const d = display || {};
  const bg = d.bg && d.bg !== 'transparent' ? d.bg : undefined;
  const opacity = typeof d.opacity === 'number' ? d.opacity : 1;
  const fit = d.fit || 'contain';
  const v = d.view;
  const outer = `relative overflow-hidden flex items-center justify-center ${className}`;

  if (v && v.w > 0 && v.h > 0) {
    const r = toRad(v.rot || 0);
    const Wr = Math.abs(Math.cos(r) * v.nw) + Math.abs(Math.sin(r) * v.nh);
    const Hr = Math.abs(Math.sin(r) * v.nw) + Math.abs(Math.cos(r) * v.nh);
    return (
      <div className={outer} style={{ background: bg, ...style }} data-testid={testId} onClick={onClick}>
        <div className="relative overflow-hidden" style={{ height: '100%', maxWidth: '100%', aspectRatio: `${v.w} / ${v.h}`, opacity }}>
          <div className="absolute" style={{ left: `${(-v.x / v.w) * 100}%`, top: `${(-v.y / v.h) * 100}%`, width: `${(Wr / v.w) * 100}%`, height: `${(Hr / v.h) * 100}%` }}>
            <img src={src} alt={alt} draggable={false} className={`absolute ${imgClassName}`}
              style={{ left: '50%', top: '50%', width: `${(v.nw / Wr) * 100}%`, height: `${(v.nh / Hr) * 100}%`, transform: `translate(-50%, -50%) rotate(${v.rot || 0}deg) scale(${v.flipX ? -1 : 1}, ${v.flipY ? -1 : 1})`, maxWidth: 'none', filter: v.filter || undefined }} />
          </div>
        </div>
      </div>
    );
  }
  return (
    <div className={outer} style={{ background: bg, ...style }} data-testid={testId} onClick={onClick}>
      <img src={src} alt={alt} draggable={false} className={`w-full h-full ${imgClassName}`} style={{ objectFit: fit, opacity }} />
    </div>
  );
}
